import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { CommonModule } from "uca-react-containers-library";
const bannerInContext = document.getElementById("banner").dataset.banner;
const environmentIncontext = document.getElementById("env").dataset.env;

const appData = {
  banner: bannerInContext,
  env: environmentIncontext,
  platform: "web",
  applicationName: "Unified Customer Account",
};

ReactDOM.render(
  <React.StrictMode>
    <CommonModule.AppProvider appData={appData}>
      <App>
        <BrowserRouter forceRefresh={true} />
      </App>
    </CommonModule.AppProvider>
  </React.StrictMode>,
  document.getElementById("uca-root")
);
